<template>
  <v-container
    text-center
    justify-center>
    <v-row
      xs12
      row
      wrap
      justify="center">
      <h1>{{ dateFormatter }} {{ etoName }}</h1>
      <v-btn
        outlined
        small
        color="info"
        class="ml-4 mt-3 font-weight-bold"
        @click="openWindowGoogleCalendar()">
        Googleカレンダーに登録
      </v-btn>
    </v-row>
    <v-row
      xs12
      row
      wrap>
      <v-col xs12>
        <v-card
          class="mx-auto"
          max-width="500">
          <v-card-subtitle class="text--primary pb-0">
            {{
              etoInfo.title
            }}
          </v-card-subtitle>
          <v-card-text>{{ etoInfo.text }}</v-card-text>
          <v-img
            class="white--text align-end"
            :src="etoInfo.imgRef" />
          <v-card-text class="text--primary">
            <div class="d-flex">
              {{ annotation.oneself }}
            </div>
            <div class="d-flex">
              {{ annotation.work }}
            </div>
            <div class="d-flex">
              {{ annotation.society }}
            </div>
            <div class="d-flex">
              {{ annotation.rokuyou }}
            </div>
            <div class="d-flex">
              {{ annotation.senjitsu }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import firebase from '@/plugins/firebase'
import { mapState, mapGetters } from 'vuex'

export default {
  data: () => ({
    date: '',
    etoName: '',
    etoInfo: {
      title: '',
      imgRef: '',
      text: '',
    },
    annotation: {
      oneself: '',
      work: '',
      society: '',
      rokuyou: '',
      senjitsu: ''
    },
    sanmeiPhases: [],
  }),
  computed: {
    dateFormatter () {
      return `${this.date.slice(0, 4)}年${Number(
        this.date.slice(5, 7)
      )} 月${Number(this.date.slice(8, 10))} 日`
    },
    ...mapState(['eto60']),
    ...mapGetters(['etoDayIndex']),
  },
  created () {
    if (!this.$route.params.date) return

    // 画面初期設定
    // 日付
    this.date = this.$route.params.date
    // 表示日の干支
    let etoDayIndex = this.etoDayIndex(this.date)
    this.etoName = this.eto60[etoDayIndex]
    const shapedEtoIndex = ('00' + etoDayIndex).slice(-2)
    // 対象日の干支情報
    firebase
      .firestore()
      .collection('eto60')
      .doc(shapedEtoIndex)
      .get()
      .then((doc) => {
        if (!doc.exists) {
          //console.log('No eto60 data in database')
        } else {
          this.etoInfo.title = doc.data().title
          this.etoInfo.text = doc.data().text
        }
      })
    // 表示日の干支のイメージ画像
    const fileName = 'eto' + shapedEtoIndex + '.jpg'
    const ref = firebase
      .storage()
      .ref()
      .child(`eto_images/${fileName}`)
    ref.getDownloadURL().then((url) => {
      this.etoInfo.imgRef = url
    })

    this.sanmeiPhases = this.$route.params.sanmeiPhases

    // 自己
    const sanmeiPhasesOnself = this.sanmeiPhases.filter(
      (x) => x.type === 'oneself'
    )
    if (sanmeiPhasesOnself.length > 0) this.annotation.oneself += '自己/結果：'
    sanmeiPhasesOnself.forEach((phase) => {
      this.buildAnnotationOneself(phase)
    })

    // 仕事
    const sanmeiPhasesWork = this.sanmeiPhases.filter(
      (x) => x.type === 'work'
    )
    if (sanmeiPhasesWork.length > 0) this.annotation.work += '仕事/課程：'
    sanmeiPhasesWork.forEach((phase) => {
      this.buildAnnotationWork(phase)
    })

    // 社会
    const sanmeiPhasesSociety = this.sanmeiPhases.filter(
      (x) => x.type === 'society'
    )
    if (sanmeiPhasesSociety.length > 0) this.annotation.society += '社会/始め：'
    sanmeiPhasesSociety.forEach((phase) => {
      this.buildAnnotationSociety(phase)
    })

    // 六曜
    const rokuyou = this.$route.params.rokuyou
    this.annotation.rokuyou = `六曜：${rokuyou}  `
    switch (rokuyou) {
    case '先勝':
      this.annotation.rokuyou += '○急用, ○訴訟, ×午後'
      break
    case '友引':
      this.annotation.rokuyou += '○午前中, ○夕刻, ○夜, ×昼, ×葬儀'
      break
    case '先負':
      this.annotation.rokuyou += '○午後, ×諸事, ×急用, ×公事'
      break
    case '仏滅':
      this.annotation.rokuyou += '何事も凶 ×閉店, ×移転, ×新規事'
      break
    case '大安':
      this.annotation.rokuyou += '何事も吉'
      break
    case '赤口':
      this.annotation.rokuyou += '○正午, ×新規事, ×諸事'
      break
    }
    // 選日
    const senjitsu = this.sanmeiPhases.filter(
      (x) => x.type === 'senjitsu'
    )
    if (senjitsu.length > 0) this.annotation.senjitsu += '選日：'
    senjitsu.forEach((phase) => {
      this.buildAnnotationSenjitsu(phase)
    })

  },
  methods: {
    buildAnnotationOneself (phase) {
      const shiName = this.etoName.slice(-1)
      // 1.支合
      if (phase.name === '支合') {
        this.annotation.oneself += '順調 '
      }
      // 2.半会
      if (phase.name === '半会') {
        this.annotation.oneself += 'プライベートに広がり '
      }
      // 3.大半会
      if (phase.name === '大半会') {
        this.annotation.oneself += '大きく広がる '
      }
      // 4.律音
      if (phase.name === '律音') {
        this.annotation.oneself += 'ターニングポイント '
      }
      // 5.害
      if (phase.name === '害') {
        if (shiName === '卯' || shiName === '辰') {
          this.annotation.oneself += '骨 筋肉 胃腸 消化器 '
        } else if (shiName === '寅' || shiName === '巳') {
          this.annotation.oneself += '肝臓 胆嚢 '
        } else if (shiName === '丑' || shiName === '午') {
          this.annotation.oneself += '栄養吸収気管 心臓 '
        } else if (shiName === '子' || shiName === '未') {
          this.annotation.oneself += '腎臓 膀胱 排泄系 '
        } else if (shiName === '亥' || shiName === '申') {
          this.annotation.oneself += '肺・呼吸器 '
        } else if (shiName === '戌' || shiName === '酉') {
          this.annotation.oneself += '自律神経 糖尿病 '
        }
      }
      // 6.刑
      if (phase.name === '自刑') {
        if (shiName === '亥') {
          this.annotation.oneself += '家庭内トラブル '
        } else if (shiName === '午') {
          this.annotation.oneself += '詐欺注意 '
        } else if (shiName === '辰') {
          this.annotation.oneself += '身内トラブル '
        } else if (shiName === '酉') {
          this.annotation.oneself += 'ギャンブル警戒 '
        }
      }
      // 7.旺気刑
      if (phase.name === '旺気刑') {
        this.annotation.oneself += '無礼注意 '
      }
      // 8.生貴刑
      if (phase.name === '生貴刑') {
        this.annotation.oneself += 'プライベートの目下に注意 '
      }
      // 9.庫気刑
      if (phase.name === '庫気刑') {
        this.annotation.oneself += '目上や終わりにトラブル '
      }
      // 10.対沖
      if (phase.name === '対沖') {
        this.annotation.oneself += 'トラブル要素 '
      }
      // 11.破
      if (phase.name === '破') {
        this.annotation.oneself += '最後が美にならない '
      }
      // 12.天剋
      if (phase.name === '天剋地冲') {
        this.annotation.oneself += '破壊要素・方針転換 '
      }
      // 13.納音
      if (phase.name === '納音') {
        this.annotation.oneself += '納める・終わらせる '
      }
      // 14.天中殺
      if (phase.name === '天中殺') {
        this.annotation.oneself += '充電日 '
      }
    },
    buildAnnotationWork (phase) {
      const shiName = this.etoName.slice(-1)
      // 1.支合
      if (phase.name === '支合') {
        this.annotation.work += '課程や心が充実 '
      }
      // 2.半会
      if (phase.name === '半会') {
        this.annotation.work += '仕事に広がり '
      }
      // 3.大半会
      if (phase.name === '大半会') {
        this.annotation.work += '大きく広がる '
      }
      // 4.律音
      if (phase.name === '律音') {
        this.annotation.work += 'ターニングポイント '
      }
      // 5.害
      if (phase.name === '害') {
        if (shiName === '寅' || shiName === '巳') {
          this.annotation.work += '頑張りすぎ 過労 '
        } else if (shiName === '丑' || shiName === '午') {
          this.annotation.work += '労して功少ない '
        } else if (shiName === '子' || shiName === '未') {
          this.annotation.work += '物事がまとまらない '
        } else if (shiName === '亥' || shiName === '申') {
          this.annotation.work += '過労 紛失 '
        } else if (shiName === '戌' || shiName === '酉') {
          this.annotation.work += '腎臓・目・骨・生殖器ケア '
        }
      }
      // 6.刑
      // if (phase.name === '自刑') {
      //   if (shiName === '亥') {
      //     this.annotation.work += '家庭内トラブル '
      //   } else if (shiName === '午') {
      //     this.annotation.work += '詐欺注意 '
      //   } else if (shiName === '辰') {
      //     this.annotation.work += '身内トラブル '
      //   } else if (shiName === '酉') {
      //     this.annotation.work += 'ギャンブル警戒 '
      //   }
      // }
      // 7.旺気刑
      if (phase.name === '旺気刑') {
        this.annotation.work += '近い人との不協和音 '
      }
      // 8.生貴刑
      if (phase.name === '生貴刑') {
        this.annotation.work += '目下・部下トラブル '
      }
      // 9.庫気刑
      if (phase.name === '庫気刑') {
        this.annotation.work += '目上トラブル '
      }
      // 10.対沖
      if (phase.name === '対沖') {
        this.annotation.work += 'トラブル要素 '
      }
      // 11.破
      if (phase.name === '破') {
        this.annotation.work += '不安や揺らぎ '
      }
      // 12.天剋
      if (phase.name === '天剋地冲') {
        this.annotation.work += '破壊要素・方針転換 '
      }
      // 13.納音
      if (phase.name === '納音') {
        this.annotation.work += '納める・終わらせる '
      }
      // 14.天中殺
      if (phase.name === '天中殺') {
        this.annotation.work += '充電日 '
      }
    },
    buildAnnotationSociety (phase) {
      const shiName = this.etoName.slice(-1)
      // 1.支合
      if (phase.name === '支合') {
        this.annotation.society += '仕事がスムーズ・新規 '
      }
      // 2.半会
      if (phase.name === '半会') {
        this.annotation.society += '社会的に広がる '
      }
      // 3.大半会
      if (phase.name === '大半会') {
        this.annotation.society += '大きな動き '
      }
      // 4.律音
      if (phase.name === '律音') {
        this.annotation.society += '継続する事に吉 '
      }
      // 5.害
      if (phase.name === '害') {
        if (shiName === '寅' || shiName === '巳') {
          this.annotation.society += 'スタートに難 '
          // } else if (shiName === '丑' || shiName === '午') {
          //   this.annotation.society += '労して功少ない '
          // } else if (shiName === '子' || shiName === '未') {
          //   this.annotation.society += '物事がまとまらない '
          // } else if (shiName === '亥' || shiName === '申') {
          //   this.annotation.society += '過労 紛失 '
        } else if (shiName === '戌' || shiName === '酉') {
          this.annotation.society += '高望みがストレス '
        }
      }
      // 6.刑
      // if (phase.name === '自刑') {
      //   if (shiName === '亥') {
      //     this.annotation.society += '家庭内トラブル '
      //   } else if (shiName === '午') {
      //     this.annotation.society += '詐欺注意 '
      //   } else if (shiName === '辰') {
      //     this.annotation.society += '身内トラブル '
      //   } else if (shiName === '酉') {
      //     this.annotation.society += 'ギャンブル警戒 '
      //   }
      // }
      // 7.旺気刑
      if (phase.name === '旺気刑') {
        this.annotation.society += '礼儀重視 '
      }
      // 8.生貴刑
      if (phase.name === '生貴刑') {
        this.annotation.society += '始めにトラブル '
      }
      // 9.庫気刑
      if (phase.name === '庫気刑') {
        this.annotation.society += '目上に注意 '
      }
      // 10.対沖
      if (phase.name === '対沖') {
        this.annotation.society += '社会的な破壊に使う '
      }
      // 11.破
      if (phase.name === '破') {
        this.annotation.society += '予期せぬ事態 '
      }
      // 12.天剋
      if (phase.name === '天剋地冲') {
        this.annotation.society += '破壊要素・横の人間関係に注意 '
      }
      // 13.納音
      if (phase.name === '納音') {
        this.annotation.society += '社会的に終わらせる事に吉 '
      }
      // 14.天中殺
      if (phase.name === '天中殺') {
        this.annotation.society += '充電日 '
      }
    },
    buildAnnotationSenjitsu (phase) {
      if (phase.name === '天赦日') {
        this.annotation.senjitsu += '最強の大吉日 '
      }
      if (phase.name === '一粒万倍日') {
        this.annotation.senjitsu += '商売始め・金銭関係に吉、借金・借入は凶 '
      }
      if (phase.name === '不成就日') {
        this.annotation.senjitsu += '成就しない日とされ事を起こす事が凶 '
      }
      if (phase.name === '三隣亡') {
        this.annotation.senjitsu += '建築に関して強い凶日 '
      }
    },
    openWindowGoogleCalendar () {
      const targetDate = `${this.date.replace(/-/g, '')}T000000`
      const sanmeiDetail =
        '-- 算命学メモ' +
        '\n' +
        this.annotation.oneself +
        '\n' +
        this.annotation.work +
        '\n' +
        this.annotation.society
      const url =
        'http://www.google.com/calendar/event?' +
        'action=' +
        'TEMPLATE' +
        '&text=' +
        encodeURIComponent('予定タイトル') +
        '&details=' +
        encodeURIComponent(sanmeiDetail) +
        '&dates=' +
        targetDate +
        '/' +
        targetDate
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped lan="scss">
.color-circle-blue {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #2196f3;
}
.color-circle-deep-purple {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #673ab7;
}
.color-circle-green {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #4caf50;
}
.color-circle-orange {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ff9800;
}
</style>
